import styled from 'styled-components';
import * as React from 'react';
import { Button } from 'antd';

export const ValidationResult = styled.span`
    font-size: 12px;
    color: red;
`;

export const AddButton = styled(Button)`
    svg {
        margin-right: 6px;
    }
    margin-right: 12px;
`;
